<template>
  <div class="villa-management">
    <h1 class="page-title">别墅详情</h1>

    <div class="toolbar">
      <el-button class="search_button" @click="openDialog('add')">新增别墅详情</el-button>
    </div>


    <el-table :data="villaDetails" style="width: 100%; margin-top: 20px;" :header-cell-style="{ color: '#333', fontWeight: 'bold', fontsize: '14px' }">
      <el-table-column label="别墅名称">
        <template #default>
          {{ houseName }}
        </template>
      </el-table-column>
      <el-table-column label="别墅类型">
        <template #default>
          {{ houseType }}
        </template>
      </el-table-column>
      <el-table-column label="详情图">
        <template #default="scope">
          <el-image :src="scope.row.houseDetailImageUrl" :preview-src-list="[scope.row.houseDetailImageUrl]" preview-teleported
            style="width: 50px; height: 50px; cursor: pointer;" fit="cover" />
        </template>
      </el-table-column>
      <el-table-column prop="imgOrder" label="顺序" />
      <el-table-column prop="status" label="状态">
        <template #default="scope">
          <el-tag :type="scope.row.status === '1' ? 'success' : 'danger'">
            {{ scope.row.status === '1' ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button @click="openDialog('edit', scope.row)" class="button">修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogMode === 'add' ? '新增别墅详情' : '修改别墅详情'" v-model="dialogVisible" width="500px">
      <el-form :model="form" label-width="100px" ref="formRef">
        <el-form-item label="详情图" prop="houseDetailImageUrl">
          <el-upload class="avatar-uploader" action="#" :auto-upload="false" :show-file-list="false"
            :on-change="handleImageChange">
            <img v-if="form.houseDetailImageUrl" :src="form.houseDetailImageUrl" class="avatar" />
            <el-icon v-else class="avatar-uploader-icon">
              <Plus />
            </el-icon>
          </el-upload>
        </el-form-item>
        <el-form-item label="顺序" prop="imgOrder">
          <el-input-number v-model="form.imgOrder" :min="1" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, getCurrentInstance } from 'vue'
import { ElMessage } from 'element-plus'
import { Plus } from '@element-plus/icons-vue'
import { useRoute } from 'vue-router';
import axios from 'axios';

const { proxy } = getCurrentInstance()

const route = useRoute();
const houseId = route.query.houseId;
const houseName = route.query.houseName;
const houseType = route.query.houseType;
// 数据列表
const villaDetails = ref([])

// 弹窗相关
const dialogVisible = ref(false)
const dialogMode = ref('') // 'add' 或 'edit'

// 表单数据
const form = reactive({
  houseId: '',
  detailId: '',
  houseDetailImageUrl: '',
  imgOrder: 1,
  status: 1,
  operateType:''//操作类型。1：新增 2：修改
})

const formRef = ref()

// 初始化数据
onMounted(() => {
  fetchVillaDetails()
})

// 获取别墅详情列表
const fetchVillaDetails = async () => {
  // 这里应该调用实际的API接口
  // 示例数据
  let url = '/house/imQueryHouseDetailById';
  proxy.$tools.request(url,
    {
      reqBody: {
        houseId: houseId,
      }
    }
  ).then(response => {
    const code = response.data.rspHead.returnCode;
    if (code === '00000000') {
      villaDetails.value = response.data.rspBody.houseDetailList;
    } else {
      ElMessage.error(response.data.rspHead.returnMsg);
    }
  }).catch(error => {
    // 处理错误情况
    ElMessage.error(error);
  });

}

// 打开弹窗
const openDialog = (mode, data) => {
  dialogMode.value = mode
  if (mode === 'edit' && data) {
    form.houseId = data.houseId
    form.houseDetailImageUrl = data.houseDetailImageUrl
    form.imgOrder = data.imgOrder
    form.status = Number(data.status);
    form.detailId = data.detailId
  } else {
    // 重置表单
    form.houseId = ''
    form.houseDetailImageUrl = ''
    form.imgOrder = 1
    form.status = 1
  }
  dialogVisible.value = true
}

// 处理图片上传
const handleImageChange = (fileObj) => {
  const file = fileObj.raw;
      if (file) {
        form.houseDetailImageUrl = URL.createObjectURL(file);
        uploadFile(file, 'image').then(url => {
          form.houseDetailImageUrl = url;
           ElMessage.success('图片上传成功')
        });
      }
}

const uploadFile = async (file, type) => {
      const formData = new FormData();
      formData.append('file', file);
      const endpoint = process.env.VUE_APP_BASE_URL + (type === 'pdf' ? '/upload/pdf' : '/upload/image');
      try {
        const response = await axios.post(endpoint, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        return response.data;
      } catch (error) {
        ElMessage.error('上传失败')
        console.error('文件上传失败', error);
        return '';
      }
   };

// 提交表单
const submitForm = async () => {
  try {
    if (dialogMode.value === 'add') {
      form.operateType = '1'
      form.houseId = houseId;
    } else {
      form.operateType = '2'
    }
    updateDetail();
    dialogVisible.value = false
    window.location.reload();
  } catch (error) {
    ElMessage.error('操作失败')
  }
}

const updateDetail = () => {
      const url = '/house/updateHouseDetail';
      proxy.$tools.request(url,
        {reqBody:form}
      ).then(response =>{
        const code = response.data.rspHead.returnCode;
        if(code === '00000000'){
          console.log('修改响应结果:'+JSON.stringify(response));
        }
      }).catch(error => {
        console.error(error);
      });
    };


</script>

<style scoped>
.villa-management {
  padding: 20px;
}

.page-title {
  text-align: center;
  margin-bottom: 20px;
}

.toolbar {
  margin-bottom: 20px;
  text-align: left;
}

.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}
.button{
  width: 100px;
  height: 30px;
  border: 1px solid #2b82cf;
  border-radius: 4px;
  font-size: 13px;
  color: #2b82cf;
}
.search_button {
  background-color: #2b82cf;
  width: 100px;
  height: 35px;
  border: 1px solid #2b82cf;
  border-radius: 4px;
  font-size: 13px;
  color: #fff;
}

.search_button:hover {
  background-color: #409eff;
  color: #fff;
}
</style>
